var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignupUserBgOld(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 224,
    viewBox: "0 0 234 224",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_5650)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1688_5650",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -102,
    y: -112,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(-102 -112)",
    fill: "url(#paint0_radial_1688_5650)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1688_5650)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 47.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 71.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 95.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 119.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 143.5,
    stroke: "#EAECF0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 56,
    r: 167.5,
    stroke: "#EAECF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1688_5650",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_5650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 224,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupUserBgOld);
export default __webpack_public_path__ + "static/media/signup_user_bg_old.b559bd8ce2eaaa221cf30994c257aaaf.svg";
export { ForwardRef as ReactComponent };